import { render } from "./PaymentScheduleTransactionsTable.vue?vue&type=template&id=c121c21a&scoped=true"
import script from "./PaymentScheduleTransactionsTable.vue?vue&type=script&lang=js"
export * from "./PaymentScheduleTransactionsTable.vue?vue&type=script&lang=js"

import "./PaymentScheduleTransactionsTable.vue?vue&type=style&index=0&id=c121c21a&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c121c21a"]])

export default __exports__